import React, { Component } from 'react'
import { Navbar, Nav, NavItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

class Header extends Component {
  render() {
    return (
      <div>  
      </div>
    );
  }
}

export default Header;